import { useCallback } from 'react'

import DevelopmentFaviconDK from 'assets/favicon/favicon_dk_development.ico'
import ProductionFaviconDK from 'assets/favicon/favicon_dk_production.ico'
import ReviewFaviconDK from 'assets/favicon/favicon_dk_review.ico'
import StagingFaviconDK from 'assets/favicon/favicon_dk_staging.ico'
import DevelopmentFaviconSE from 'assets/favicon/favicon_se_development.ico'
import ProductionFaviconSE from 'assets/favicon/favicon_se_production.ico'
import ReviewFaviconSE from 'assets/favicon/favicon_se_review.ico'
import StagingFaviconSE from 'assets/favicon/favicon_se_staging.ico'

import { useCountry } from './useCountry'

const faviconMap = {
  dk: {
    development: DevelopmentFaviconDK,
    production: ProductionFaviconDK,
    staging: StagingFaviconDK,
    review: ReviewFaviconDK,
  },
  no: {
    development: DevelopmentFaviconDK,
    production: ProductionFaviconDK,
    staging: StagingFaviconDK,
    review: ReviewFaviconDK,
  },
  se: {
    development: DevelopmentFaviconSE,
    production: ProductionFaviconSE,
    staging: StagingFaviconSE,
    review: ReviewFaviconSE,
  },
  es: {
    development: DevelopmentFaviconDK,
    production: ProductionFaviconDK,
    staging: StagingFaviconDK,
    review: ReviewFaviconDK,
  },
  fr: {
    development: DevelopmentFaviconDK,
    production: ProductionFaviconDK,
    staging: StagingFaviconDK,
    review: ReviewFaviconDK,
  },
}

export const useFavicon = () => {
  const country = useCountry()
  const environment = import.meta.env.VITE_NODE_ENV

  const createFavicon = useCallback(() => {
    const favicon = document.createElement('link')

    favicon.rel = 'icon'

    document.head.appendChild(favicon)

    favicon.href = faviconMap[country][environment]
  }, [country, environment])

  return {
    createFavicon,
  }
}
